import Vue from 'vue'
import InfiniteLoading from 'vue-infinite-loading';


Vue.use(InfiniteLoading, {
  slots: {
    // keep default styles
    noResults: '',

    // remove default styles
    noMore: '没有更多了~',

    // hide slot
    error: '',
  }
 });
